const c = {
  name: "Fitbit",
  dimensions: { width: 22, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22 40" style="enable-background:new 0 0 22 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,26v2h6v-2H6z"/>
		<path class="st0" d="M12,22v2H6v-2H12z"/>
		<path class="st0" d="M8.4,19.8c0,0,0,0,0.6-0.8l0.6,0.8L9,20.2L8.4,19.8z"/>
		<path class="st0" d="M8.4,19.8L8.4,19.8L9,19c0.6,0.8,0.6,0.8,0.6,0.8l0,0l0,0l0,0l0,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.2-0.2,0.4-0.3
			c0.3-0.2,0.7-0.6,1.1-1c0.4-0.4,0.8-0.9,1.2-1.5c0.3-0.6,0.6-1.2,0.6-2c0-1.5-1.3-3-3-3c-0.3,0-0.7,0.1-1,0.2
			C8.7,12.1,8.3,12,8,12c-1.7,0-3,1.5-3,3c0,0.7,0.3,1.4,0.6,2c0.3,0.6,0.8,1.1,1.2,1.5c0.4,0.4,0.8,0.8,1.1,1
			c0.2,0.1,0.3,0.2,0.4,0.3C8.3,19.8,8.4,19.8,8.4,19.8L8.4,19.8L8.4,19.8L8.4,19.8z M7,15c0-0.5,0.5-1,1-1c0.2,0,0.4,0.1,0.5,0.1
			L9,14.4l0.5-0.3C9.6,14.1,9.8,14,10,14c0.5,0,1,0.5,1,1c0,0.3-0.1,0.6-0.3,1c-0.2,0.4-0.5,0.7-0.9,1.1c-0.3,0.3-0.6,0.5-0.8,0.7
			c-0.2-0.2-0.5-0.4-0.8-0.7c-0.3-0.3-0.7-0.7-0.9-1.1C7.1,15.6,7,15.3,7,15z"/>
		<path class="st0" d="M3.2,0h11.7l1,6.1C17.1,6.5,18,7.6,18,9v22c0,1.4-0.9,2.5-2.1,2.9l-1,6.1H3.2l-1-6.1C0.9,33.5,0,32.4,0,31V9
			c0-1.4,0.9-2.5,2.1-2.9L3.2,0z M13.2,2H4.8L4.2,6h9.6L13.2,2z M4.8,38h8.3l0.7-4H4.2L4.8,38z M3,8C2.4,8,2,8.4,2,9v22
			c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V9c0-0.6-0.4-1-1-1H3z"/>
		<path class="st0" d="M22,16v8h-2v-8H22z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Fitbit
};
